import { consumeContext } from "../../lib/consume_context"
import { Game } from "../../lib/game"
import { PlayerSetupComponent } from "./component"

export const PlayerSetupConsumer = consumeContext({
  Context: Game.Context,
  provideTo: "gameContext",
})(PlayerSetupComponent)
